//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixinComponent from './mixinComponent.js'
export default {
  name: 'VyInputSelect',
  mixins: [mixinComponent],
  props: {
    params: Object, // select 参数列表
    fieldName: String, // 字段名
    pickList: {type: [Array, String], default: () => []}, // 选项列表
    value: [String, Number, Array, Boolean], // value需要双向绑定传递到组件外部
    text: String, // text需要双向绑定传递到组件外部

    title: String, // 标题
    placeholder: {type: String, default: '请选择'}, // 占位提示文字
    required: {type: Boolean, default: false}, // 必填
    readonly: {type: Boolean, default: false}, // 只读
    disabled: {type: Boolean, default: false}, // 禁用
    hide: {type: Boolean, default: false}, // 隐藏
  },
  methods: {
    cellClick () {
      if(!this.disabled && !this.readonly) {
        let pickList =
          process.env.SERVER !== $CONST_STRING.BACK_END
            ? this.pickList
            : JSON.parse(this.pickList)
        this.$emit('vy-select-click', {
          title: this.title,
          target: this.target,
          key: this.fieldKey,
          value: this.value,
          params: this.params,
          pickList,
          fieldName: this.fieldName,
        })
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/basic/VyInputSelect.vue